import { CurrentUser, HiddenComponentProps, HtmlDocPageData, MenuResponse, OgData } from 'types';
import { CustomerPageWrapper } from 'containers/CustomerPageWrapper';

import styles from './HtmlDocPage.module.scss';

export type HtmlDocPageProps = {
  headTitle: string;
  menuData: MenuResponse;
  ogData?: OgData[];
  pageData: HtmlDocPageData;
  title: string;
  user?: CurrentUser;
  seoHiddenProps?: HiddenComponentProps;
};

export const HtmlDocPage = ({
  headTitle,
  menuData = {} as MenuResponse,
  ogData,
  pageData: { text },
  title,
  user,
  seoHiddenProps,
}: HtmlDocPageProps) => {
  return (
    <CustomerPageWrapper
      menuData={menuData}
      user={user}
      headTitle={headTitle}
      withFooter={false}
      ogData={ogData}
      hiddenComponentProps={seoHiddenProps}
    >
      <>
        <div className={styles.container}>
          <div className={styles.headerWrapper}>
            <div className={styles.header}>
              <h2>{title}</h2>
            </div>
          </div>
          <div className={styles.contentWrapper}>
            <span className={styles.content} dangerouslySetInnerHTML={{ __html: text || '' }} />
          </div>
        </div>
      </>
    </CustomerPageWrapper>
  );
};
